import { useState, useEffect } from 'react';
import base from '../pages/TaxasEntrega.module.css';
import styles from './TaxaPorKm.module.css';
import { MdAdd, MdDelete, MdCheckCircle, MdPlace } from 'react-icons/md';

const API_URL = process.env.REACT_APP_API_URL;

function cabecalhos() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

async function chamar(caminho, opcoes = {}) {
  const res = await fetch(`${API_URL}/whatsapp/taxas-entrega/km${caminho}`, { headers: cabecalhos(), ...opcoes });
  const dados = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(dados.error || 'Falha na requisição');
  return dados;
}

const reais = (v) => `R$ ${Number(v).toFixed(2).replace('.', ',')}`;
const km = (v) => String(v).replace('.', ',');

const MOTIVOS = {
  nao_encontrado: 'O Google não encontrou esse endereço. O bot pediria para o cliente mandar de novo.',
  impreciso: 'Endereço genérico demais (só cidade ou bairro). O bot pediria rua e número.',
  indisponivel: 'Não foi possível calcular agora (Google fora do ar ou configuração incompleta). O bot chamaria um atendente.'
};

// Aba "Por distância (km)" de Taxa de Entrega: endereço do restaurante, faixas
// e um simulador. Quem calcula de verdade é o bot (ver taxaKm.service.js).
function TaxaPorKm({ estabelecimentoId, dados, onAtualizar }) {
  const [endereco, setEndereco] = useState('');
  const [faixas, setFaixas] = useState([]);
  const [teste, setTeste] = useState('');
  const [resultado, setResultado] = useState(null);
  const [ocupado, setOcupado] = useState('');

  // Quando os dados do servidor mudam, a lista editável acompanha.
  useEffect(() => {
    setFaixas(dados.faixas.map((f) => ({ ate_km: String(f.ate_km), valor: String(f.valor) })));
    setEndereco(dados.origem?.endereco || '');
  }, [dados]);

  const executar = async (rotulo, fn) => {
    setOcupado(rotulo);
    try { await fn(); } catch (e) { alert(e.message); } finally { setOcupado(''); }
  };

  const salvarOrigem = () => executar('origem', async () => {
    onAtualizar(await chamar('/origem', { method: 'PUT', body: JSON.stringify({ id_estabelecimento: estabelecimentoId, endereco }) }));
  });

  const salvarFaixas = () => executar('faixas', async () => {
    onAtualizar(await chamar('/faixas', {
      method: 'PUT',
      body: JSON.stringify({
        id_estabelecimento: estabelecimentoId,
        faixas: faixas.map((f) => ({ ate_km: Number(String(f.ate_km).replace(',', '.')), valor: Number(String(f.valor).replace(',', '.')) }))
      })
    }));
    alert('Faixas salvas!');
  });

  const testar = () => executar('teste', async () => {
    setResultado(await chamar('/simular', { method: 'POST', body: JSON.stringify({ id_estabelecimento: estabelecimentoId, endereco: teste }) }));
  });

  const alterarFaixa = (indice, campo, valor) => setFaixas(faixas.map((f, i) => (i === indice ? { ...f, [campo]: valor } : f)));
  const maiorFaixa = faixas.reduce((m, f) => Math.max(m, Number(String(f.ate_km).replace(',', '.')) || 0), 0);

  return (
    <>
      {!dados.maps_configurado && (
        <div className={styles.aviso}>
          O Google Maps ainda não está configurado no servidor, então a cobrança por km não pode ser usada. Fale com o suporte do Speed Order.
        </div>
      )}

      <section className={base.painelPadrao} style={{ flexDirection: 'column', alignItems: 'stretch' }}>
        <div>
          <strong className={base.painelPadraoTitulo}>Endereço do restaurante</strong>
          <p className={base.painelPadraoTexto}>É daqui que a distância até o cliente é medida (pela rua, não em linha reta). Informe rua, número, bairro e cidade.</p>
        </div>
        <div className={styles.linha}>
          <input className={base.inputTaxa} value={endereco} onChange={(e) => setEndereco(e.target.value)} placeholder="Ex: Rua Itália, 245, Centro, Mauá - SP" />
          <button className={base.btnSalvarPadrao} onClick={salvarOrigem} disabled={ocupado === 'origem' || endereco.trim().length < 8}>
            {ocupado === 'origem' ? 'Localizando...' : 'Localizar e salvar'}
          </button>
        </div>
        {dados.origem && (
          <p className={styles.confirmado}><MdCheckCircle /> Localizado: <strong>{dados.origem.endereco}</strong></p>
        )}
      </section>

      <section className={base.painelPadrao} style={{ flexDirection: 'column', alignItems: 'stretch' }}>
        <div>
          <strong className={base.painelPadraoTitulo}>Faixas de distância</strong>
          <p className={base.painelPadraoTexto}>
            Vale a primeira faixa que cobre a distância. Acima da última faixa o cliente é encaminhado a um atendente
            {maiorFaixa > 0 ? ` (hoje: mais de ${km(maiorFaixa)} km)` : ''}.
          </p>
        </div>

        <div className={styles.faixas}>
          {faixas.length === 0 && <p className={styles.vazio}>Nenhuma faixa ainda. Adicione a primeira abaixo.</p>}
          {faixas.map((f, i) => (
            <div key={i} className={styles.faixa}>
              <span>Até</span>
              <div className={base.inputComPrefixo} style={{ width: 130 }}>
                <input className={base.inputTaxaValor} type="number" min="0.1" step="0.1" value={f.ate_km} onChange={(e) => alterarFaixa(i, 'ate_km', e.target.value)} />
                <span>km</span>
              </div>
              <span>cobra</span>
              <div className={base.inputComPrefixo} style={{ width: 150 }}>
                <span>R$</span>
                <input className={base.inputTaxaValor} type="number" min="0" step="0.01" value={f.valor} onChange={(e) => alterarFaixa(i, 'valor', e.target.value)} />
              </div>
              <button className={base.btnIcone} title="Remover faixa" onClick={() => setFaixas(faixas.filter((_, idx) => idx !== i))}><MdDelete /></button>
            </div>
          ))}
        </div>

        <div className={styles.linha}>
          <button className={base.btnImportar} onClick={() => setFaixas([...faixas, { ate_km: '', valor: '' }])}><MdAdd /> <span>Adicionar faixa</span></button>
          <button className={base.btnSalvarPadrao} onClick={salvarFaixas} disabled={ocupado === 'faixas' || faixas.length === 0}>
            {ocupado === 'faixas' ? 'Salvando...' : 'Salvar faixas'}
          </button>
        </div>
      </section>

      <section className={base.painelPadrao} style={{ flexDirection: 'column', alignItems: 'stretch' }}>
        <div>
          <strong className={base.painelPadraoTitulo}>Testar um endereço</strong>
          <p className={base.painelPadraoTexto}>Digite o endereço de um cliente para ver a distância e a taxa que o bot cobraria. Cada teste conta na cota do Google.</p>
        </div>
        <div className={styles.linha}>
          <input className={base.inputTaxa} value={teste} onChange={(e) => { setTeste(e.target.value); setResultado(null); }} placeholder="Ex: Rua das Flores, 12, Vila Bocaina, Mauá" />
          <button className={base.btnSalvarPadrao} onClick={testar} disabled={ocupado === 'teste' || teste.trim().length < 8 || !dados.origem || faixas.length === 0}>
            {ocupado === 'teste' ? 'Calculando...' : 'Testar'}
          </button>
        </div>
        {resultado && (resultado.ok ? (
          <div className={styles.resultadoOk}>
            <MdPlace />
            <div>
              <strong>{km(resultado.distancia_km)} km → taxa de {reais(resultado.taxa)}</strong>
              <span>Faixa até {km(resultado.ate_km)} km · Endereço entendido: {resultado.endereco_formatado}</span>
            </div>
          </div>
        ) : (
          <div className={styles.resultadoErro}>
            {resultado.motivo === 'fora_da_area'
              ? `Fora da área${resultado.distancia_km ? `: ${km(resultado.distancia_km)} km (máximo ${km(resultado.max_km)} km)` : ''}. O bot chamaria um atendente.`
              : MOTIVOS[resultado.motivo] || 'Não foi possível calcular.'}
          </div>
        ))}
      </section>
    </>
  );
}

export default TaxaPorKm;
